export enum ESetPasswordMode {
    signUp = 'sign-up',
    resetPassword = 'reset-password'
}

export enum ESetPasswordStep {
    otp = 'set-otp',
    password = 'set-password'
}

export enum EUpdatePasswordMode {
    update = 'update',
    restore = 'restore'
}
